import { Carousel, Title } from '../../components'
import styles from './styles.module.css'

const EarnMoneySection = () => {
    return (
        <div className={styles.wrapper}>
            <Title
                text="Earn money with us"
                className="text-purple"
                bigTitle
                titleMargin
            />
            <Carousel />
        </div>
    )
}

export default EarnMoneySection
